import React from 'react';
import { Button } from '../components/ui/Button';
import { ShoppingBagIcon, BarChart2Icon, ZapIcon, UsersIcon, CheckIcon } from 'lucide-react';
export function ShoplinkyPage() {
  return <div className="w-full" data-id="element-658">
      {/* Hero Section */}
      <section className="bg-black text-white py-24 relative" data-id="element-659">
        <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-660">
          <img src="https://images.unsplash.com/photo-1556742208-999815fca738?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80" alt="E-commerce" className="w-full h-full object-cover opacity-40" data-id="element-661" />
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-662">
          <div className="max-w-3xl" data-id="element-663">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" data-id="element-664">
              Shoplinky
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-8" data-id="element-665">
              The AI-powered influencer commerce platform enabling creators to
              monetize their content and build sustainable businesses.
            </p>
            <Button href="/contact" size="lg" data-id="element-666">
              Get Started
            </Button>
          </div>
        </div>
      </section>
      {/* Overview Section */}
      <section className="py-16 md:py-24 bg-white" data-id="element-667">
        <div className="container mx-auto px-4" data-id="element-668">
          <div className="max-w-4xl mx-auto" data-id="element-669">
            <div className="flex justify-center mb-12" data-id="element-670">
              <ShoppingBagIcon className="h-20 w-20 text-black" data-id="element-671" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-8 text-center" data-id="element-672">
              Monetize Your Influence
            </h2>
            <p className="text-lg text-gray-600 mb-8 text-center" data-id="element-673">
              Shoplinky is a revolutionary platform that empowers content
              creators to transform their influence into income. Our AI-powered
              solution seamlessly connects your content with relevant products,
              enabling effortless monetization across all your social channels.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16" data-id="element-674">
              <div className="bg-gray-50 p-8 rounded-lg text-center" data-id="element-675">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-676">
                  <ZapIcon className="h-8 w-8 text-black" data-id="element-677" />
                </div>
                <h3 className="text-xl font-semibold text-black mb-3" data-id="element-678">
                  AI-Powered
                </h3>
                <p className="text-gray-600" data-id="element-679">
                  Advanced algorithms that match your content with the most
                  relevant and high-converting products.
                </p>
              </div>
              <div className="bg-gray-50 p-8 rounded-lg text-center" data-id="element-680">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-681">
                  <UsersIcon className="h-8 w-8 text-black" data-id="element-682" />
                </div>
                <h3 className="text-xl font-semibold text-black mb-3" data-id="element-683">
                  Creator-Focused
                </h3>
                <p className="text-gray-600" data-id="element-684">
                  Built specifically for content creators, with tools designed
                  to maximize your earning potential.
                </p>
              </div>
              <div className="bg-gray-50 p-8 rounded-lg text-center" data-id="element-685">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-686">
                  <BarChart2Icon className="h-8 w-8 text-black" data-id="element-687" />
                </div>
                <h3 className="text-xl font-semibold text-black mb-3" data-id="element-688">
                  Data-Driven
                </h3>
                <p className="text-gray-600" data-id="element-689">
                  Comprehensive analytics to track performance and optimize your
                  monetization strategy.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Features Section */}
      <section className="py-16 md:py-24 bg-gray-50" data-id="element-690">
        <div className="container mx-auto px-4" data-id="element-691">
          <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-692">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-6" data-id="element-693">
              Key Features
            </h2>
            <p className="text-lg text-gray-600" data-id="element-694">
              Everything you need to transform your content into a thriving
              commerce business.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-695">
            <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-696">
              <h3 className="text-xl font-semibold text-black mb-4" data-id="element-697">
                AI Product Recommendations
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-698">
                Our proprietary AI analyzes your content and audience to
                recommend the most relevant products that will drive the highest
                conversion rates and commissions.
              </p>
              <ul className="space-y-2" data-id="element-699">
                <li className="flex items-start" data-id="element-700">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-701" />
                  <span className="text-gray-600" data-id="element-702">
                    Content analysis for contextual matching
                  </span>
                </li>
                <li className="flex items-start" data-id="element-703">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-704" />
                  <span className="text-gray-600" data-id="element-705">
                    Audience preference prediction
                  </span>
                </li>
                <li className="flex items-start" data-id="element-706">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-707" />
                  <span className="text-gray-600" data-id="element-708">
                    Continuous learning and optimization
                  </span>
                </li>
              </ul>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-709">
              <h3 className="text-xl font-semibold text-black mb-4" data-id="element-710">
                Seamless Social Integration
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-711">
                Connect all your social media platforms and monetize your
                content across every channel with a unified shopping experience
                for your audience.
              </p>
              <ul className="space-y-2" data-id="element-712">
                <li className="flex items-start" data-id="element-713">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-714" />
                  <span className="text-gray-600" data-id="element-715">
                    Multi-platform support (Instagram, YouTube, TikTok, etc.)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-716">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-717" />
                  <span className="text-gray-600" data-id="element-718">
                    Custom shopping links for each platform
                  </span>
                </li>
                <li className="flex items-start" data-id="element-719">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-720" />
                  <span className="text-gray-600" data-id="element-721">
                    Unified analytics across all channels
                  </span>
                </li>
              </ul>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-722">
              <h3 className="text-xl font-semibold text-black mb-4" data-id="element-723">
                Automated Affiliate Marketing
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-724">
                Access thousands of affiliate programs through our platform with
                automatic link generation, commission tracking, and payment
                processing.
              </p>
              <ul className="space-y-2" data-id="element-725">
                <li className="flex items-start" data-id="element-726">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-727" />
                  <span className="text-gray-600" data-id="element-728">
                    Instant access to premium affiliate networks
                  </span>
                </li>
                <li className="flex items-start" data-id="element-729">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-730" />
                  <span className="text-gray-600" data-id="element-731">
                    Automated link generation and tracking
                  </span>
                </li>
                <li className="flex items-start" data-id="element-732">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-733" />
                  <span className="text-gray-600" data-id="element-734">
                    Consolidated payments and reporting
                  </span>
                </li>
              </ul>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-735">
              <h3 className="text-xl font-semibold text-black mb-4" data-id="element-736">
                Creator Analytics Dashboard
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-737">
                Comprehensive analytics to track your performance, understand
                your audience, and optimize your monetization strategy.
              </p>
              <ul className="space-y-2" data-id="element-738">
                <li className="flex items-start" data-id="element-739">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-740" />
                  <span className="text-gray-600" data-id="element-741">
                    Real-time performance metrics
                  </span>
                </li>
                <li className="flex items-start" data-id="element-742">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-743" />
                  <span className="text-gray-600" data-id="element-744">
                    Audience insights and behavior analysis
                  </span>
                </li>
                <li className="flex items-start" data-id="element-745">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-746" />
                  <span className="text-gray-600" data-id="element-747">
                    Revenue forecasting and optimization suggestions
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-black text-white" data-id="element-748">
        <div className="container mx-auto px-4 bg-pattern" data-id="element-749">
          <div className="max-w-4xl mx-auto text-center" data-id="element-750">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-751">
              Ready to Monetize Your Influence?
            </h2>
            <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-752">
              Join thousands of creators who are turning their passion into
              profit with Shoplinky's AI-powered commerce platform.
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-753">
              <Button href="/contact" size="lg" data-id="element-754">
                Get Started Today
              </Button>
              <Button href="/contact" variant="outline" size="lg" className="border-white text-white hover:bg-gray-900" data-id="element-755">
                Request a Demo
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>;
}